// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_SEARCH_BUTTON = "H\u013eadaj";
export const FACET_SELECT_NO_OPTIONS = "Nie je mo\u017en\u00e9 vybra\u0165 \u017eiadnu hodnotu";
